var $083b0cad27fdbd06$exports = {};
$083b0cad27fdbd06$exports = {
  "Clear search": "Limpar pesquisa"
};
export { $083b0cad27fdbd06$exports as default };